import { tv } from '~/utils/tv'

export const cardCategoryBoxVariants = tv({
  base: 'flex flex-col items-center justify-center gap-twopulse border-none',
  variants: {
    disabled: {
      true: 'cursor-not-allowed text-text-neutral-disabled outline-none',
    },
    orientation: {
      horizontal: 'rounded-pill',
      vertical: 'rounded-hugecontainer',
    },
    context: {
      brand: '',
      neutral: '',
    },
  },
  compoundVariants: [
    {
      orientation: 'horizontal',
      disabled: false,
      class: 'outline-action-border-focused outline-offset-4 focus:outline-1',
    },
    {
      orientation: 'vertical',
      disabled: false,
      class: 'outline-action-border-focused outline-offset-4 focus:outline-1',
    },
    {
      context: 'brand',
      disabled: true,
      //@TODO alterar o token bg-browsing-fill-onbrand-disabled
      class: 'border-border-browsing-border-onbrand-disabled bg-[#E6E6E6]',
    },
    {
      context: 'neutral',
      disabled: true,
      class:
        'border-action-border-neutral-tertiary-disabled bg-action-fill-neutral-tertiary-disabled',
    },
  ],
})

export const cardCategoryContainerVariants = tv({
  base: 'flex min-w-[6rem] border-none bg-action-fill-emphasis-enabled py-threepulse outline-none',
  variants: {
    orientation: {
      vertical: 'max-w-[6rem] flex-col items-center rounded-hugecontainer',
      horizontal:
        'h-large max-h-large min-h-large flex-row items-center justify-center gap-twopulse rounded-pill p-threepulse pr-fourpulse',
    },
    disabled: {
      true: 'cursor-not-allowed bg-action-fill-emphasis-disabled',
      false:
        'hover:bg-action-fill-emphasis-hovered active:bg-action-fill-emphasis-pressed',
    },
    context: {
      brand: 'roudend-pill border-none',
      neutral: 'roudend-pill border-none',
    },
  },
  compoundVariants: [
    {
      disabled: false,
      context: 'brand',
      class:
        'bg-browsing-fill-onbrand-enabled pressed:bg-browsing-fill-onbrand-pressed hover:bg-browsing-fill-onbrand-hovered active:bg-browsing-fill-onbrand-activated',
    },
    {
      disabled: false,
      context: 'neutral',
      class:
        'bg-action-fill-neutral-tertiary pressed:bg-action-fill-neutral-tertiary-pressed hover:bg-action-fill-neutral-tertiary-hovered active:bg-action-fill-neutral-tertiary-activated',
    },
    {
      disabled: true,
      context: 'neutral',
      class: 'bg-action-fill-neutral-tertiary-disabled',
    },
    {
      disabled: true,
      context: 'brand',
      class: 'bg-action-fill-neutral-tertiary-disabled',
    },
  ],
})

export const cardCategoryLabelVariants = tv({
  base: 'font-rdmodern text-text-neutral text-threeandhalfpulse leading-small',
  variants: {
    orientation: {
      vertical: 'line-clamp-2 text-center',
      horizontal: 'line-clamp-1',
    },
    context: {
      brand: '',
      neutral: '',
    },
    disabled: {
      true: 'text-text-neutral-disabled',
      false: '',
    },
    isPressed: {
      true: '',
      false: '',
    },
    isHovered: {
      true: '',
      false: '',
    },
  },
  compoundVariants: [
    {
      disabled: true,
      context: 'neutral',
      class: 'text-text-neutral-disabled',
    },
    {
      disabled: true,
      context: 'brand',
      class: 'text-text-neutral-disabled',
    },
    {
      isPressed: false,
      disabled: false,
      context: 'brand',
      class: 'active:font-semibold active:text-action-text-onbrand-activated',
    },
    {
      isPressed: false,
      disabled: false,
      context: 'neutral',
      class: 'font-regular',
    },
    {
      isPressed: true,
      disabled: false,
      context: 'brand',
      class: 'font-semibold',
    },
    {
      isPressed: true,
      disabled: false,
      context: 'neutral',
      class: 'font-semibold',
    },
    {
      context: undefined,
      orientation: 'horizontal',
      class: 'font-semibold',
    },
    {
      context: undefined,
      orientation: 'vertical',
      class: 'font-semibold',
    },
    {
      context: 'brand',
      isHovered: true,
      disabled: false,
      class: 'text-action-text-onbrand-hovered',
    },
    {
      context: 'brand',
      isPressed: true,
      class: 'text-action-text-onbrand-pressed',
    },
  ],
})
